import React, { type FC } from 'react';

import { Inline, Stack } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';

export const LoadingBody: FC<{}> = () => (
	<Stack grow="fill">
		<Inline grow="fill" alignInline="center" alignBlock="center">
			<Spinner size="large" interactionName="load" />
		</Inline>
	</Stack>
);
